export default "__VITE_ASSET__5c71cbfa__"